import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import EmptyList from "go-core/components/EmptyList";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { FILTER_SEPARATOR, NEW_WAY_TO_ENCODING_FILTER_SIGN } from "go-list/core/components/Filter/services";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { PosReportApi } from "../../../../../../../../../../services/Api/Organization/types";

interface Props {
	report: PosReportApi;
}

const SourcesTabPreview = ({ report }: Props) => {
	const { order_sources: orderSources, id: reportId, order_count: orderCount, order_amount: orderAmount } = report;
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);

	const getOrdersListRedirectLink = (sourceName: string): string => {
		const decodedFiltersValue = `${NEW_WAY_TO_ENCODING_FILTER_SIGN}${FILTER_SEPARATOR}report|e=${reportId}${FILTER_SEPARATOR}source|e=${sourceName}`;
		const encodedFiltersValue = btoa(unescape(encodeURIComponent(decodedFiltersValue)));

		return `/${organization.id}/sales/orders?f=${encodedFiltersValue}`;
	};

	return (
		<Card>
			<Card.Body>
				{orderSources.length > 0 ? (
					<div className="table-responsive">
						<table className="table table-preview">
							<thead>
								<tr>
									<th>{t("common.word.name", { ns: "lib" })}</th>
									<th>{t("common.word.amount")}</th>
									<th>{t("common.word.quantity")}</th>
									<th />
								</tr>
							</thead>
							<tbody>
								{orderSources.map(({ total_amount, count, source_name }) => (
									<tr key={source_name}>
										<td>{source_name}</td>
										<td>{FormatMoney(total_amount)}</td>
										<td>{count}</td>
										<td>
											<Link
												className="btn btn-primary-light me-1"
												to={getOrdersListRedirectLink(source_name)}
												target="_blank"
												rel="noreferrer"
											>
												{t("modules.pos_report.action.show_orders.title")}
											</Link>
										</td>
									</tr>
								))}
								<tr className="summary">
									<td>
										<strong>{t("common.word.sum")}</strong>
									</td>
									<td>
										<strong>{FormatMoney(orderAmount)}</strong>
									</td>
									<td>
										<strong>{orderCount}</strong>
									</td>
									<td />
								</tr>
							</tbody>
						</table>
					</div>
				) : (
					<EmptyList />
				)}
			</Card.Body>
		</Card>
	);
};

export default SourcesTabPreview;
